import { render } from "./stronaKontaWyloguj.vue?vue&type=template&id=be53973e&scoped=true"
import script from "./stronaKontaWyloguj.vue?vue&type=script&lang=js"
export * from "./stronaKontaWyloguj.vue?vue&type=script&lang=js"

import "./stronaKontaWyloguj.vue?vue&type=style&index=0&id=be53973e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be53973e"]])

export default __exports__